import React, { useEffect, useState } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Button } from "primereact/button";
import { Fetch } from "../../../../shared/Fetch";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { Toolbar } from "primereact/toolbar";
import { format } from "date-fns";
import { Dialog } from "primereact/dialog";
import { Card } from "primereact/card";
import { ILogin, IPermissionProps } from "../../../../models/Login";
import { ApproveSelection } from "./ApproveSelection";

interface IProps {
    reload: boolean,
    setModal: (modal: { open: boolean }) => void,
    permission: IPermissionProps,
    toast: any,
}

export interface ITrainer {
    trainer_ID?: number,
    login_ID?: number,
    user_Name?: string,
    company_Name?: string,
    branchName?: string,
    approve_Status?: boolean,
    rejection_Comment?: string,
    added_By?: string,
    added_On?: Date,
}

export const Table = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: ITrainer[], loading: boolean });
    const [openRejection, setOpenRejection] = useState({ open: false, comment: "" } as { open: boolean, comment: string });
    const [openEditFrom, setOpenEditFrom] = useState({ open: false, singleData: {} } as { open: boolean, singleData: ITrainer });

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const RemoveTeam = async (rowData: ITrainer) => {
        const response = await Fetch("CarnivalTraining/removeTrainer", "DELETE", null, `trainer_ID=${rowData.trainer_ID}`, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Removed", life: 3000 });
            loadTableData();
        }
    }

    const confirmDelete = (rowData: ITrainer) => {
        confirmDialog({
            message: `Are you sure you want to delete this Trainer`,
            header: 'Confirm Delete',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            accept: () => RemoveTeam(rowData),
            reject: () => props.toast.current.show({ severity: "error", detail: "Cancelled", life: 3000 })
        });
    };

    const openEdit = async (rowData: ITrainer) => {
        setOpenEditFrom({ open: true, singleData: rowData })
    }

    const action = (rowData: ITrainer) => {
        return (
            <div className="flex gap-3">
                {/* {(rowData.approve_Status === false || rowData.approve_Status === null || (_roles.includes(1) || _roles.includes(26))) && props.permission.is_Delete && <Button className="pi pi-trash bg-white border-none" style={{ color: "red" }} onClick={() => confirmDelete(rowData)}></Button>} */}
                {(rowData.approve_Status === null || rowData.approve_Status === false || (_roles.includes(1) || _roles.includes(26))) && (props.permission.is_Update || (_roles.includes(1) || _roles.includes(26))) && <Button className="pi pi-pencil text-primary bg-white border-none" onClick={() => openEdit(rowData)}></Button>}
            </div>
        );
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("CarnivalTraining/getTrainer", "GET", null, null, props.toast);
        if (response) {
            const data = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const leftToolbarTemplate = () => {
        return (

            <React.Fragment>
                <div className="my-2">
                    {props.permission.is_Create && <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />}
                </div>
            </React.Fragment>
        );
    };

    const fromDate = (rowData: ITrainer) => {
        let date;
        if (rowData.added_On) date = format(new Date(rowData.added_On), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const approveStatus = (rowData: ITrainer) => {
        return (<p className={rowData.approve_Status === false ? "cursor-pointer underline" : ""} style={{ color: rowData.approve_Status === false ? "red" : (rowData.approve_Status === true ? "green" : "black") }} onClick={() => {
            if (rowData.approve_Status === false) {
                setOpenRejection({ open: true, comment: rowData.rejection_Comment || "" });
            }
        }}>{rowData.approve_Status === true ? "Accepted" : (rowData.approve_Status === false ? "Rejected" : "Pending")}</p>);
    };

    const openNew = () => {
        props.setModal({ open: true });
    };

    useEffect(() => {
        loadTableData();
    }, [props.reload]);

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>
            <DataTable value={tableData.tableData} loading={tableData.loading} header={<p>Training Trainers</p>}>
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field="user_Name" header="Trainer" />
                <Column field="company_Name" header="Company" />
                <Column field="branchName" header="Branch" />
                <Column field="added_By" header="Added By" />
                <Column field="approve_Status" header="Approve Status" body={(rowData: ITrainer) => approveStatus(rowData)} />
                <Column field="added_On" header="Added On" body={(rowData: ITrainer) => fromDate(rowData)} />
                {(_roles.includes(1) || _roles.includes(26) || _roles.includes(48)) && <Column header="Action" body={action} />}
            </DataTable>
            <Dialog visible={openRejection.open} style={{ width: '50vw' }} header="Rejection Reason" modal className="p-fluid" onHide={() => setOpenRejection({ open: false, comment: "" })}>
                <Card>
                    {openRejection.comment}
                </Card>
            </Dialog>
            <ConfirmDialog />
            <ApproveSelection open={openEditFrom.open} singleData={openEditFrom.singleData} hideDialog={() => setOpenEditFrom({ open: false, singleData: {} })} toast={props.toast} reloadTable={() => loadTableData()} />
        </>
    );
}